import { render, staticRenderFns } from "./TicketStatus.vue?vue&type=template&id=22ca2673&scoped=true&"
import script from "./TicketStatus.vue?vue&type=script&lang=js&"
export * from "./TicketStatus.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatus.vue?vue&type=style&index=0&id=22ca2673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca2673",
  null
  
)

export default component.exports